import React, { useContext, useEffect, useState } from "react";
import { addUser, getUserById, updateUserAdmin } from "../../../api/usersApi";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import "./styles/addEdit.css";
import { AuthContext } from "../../../Contexts/AuthContext";

export function AddEditUser() {
    const {user} = useContext(AuthContext);
    const { id } = useParams();
    const navigate = useNavigate();

    const isEdit = !!id;

    const [form, setForm] = useState({
        nom: "",
        email: "",
        password: "",
    });

    useEffect(() => {
        if (isEdit) {
            getUserById(id).then(data => {
                setForm({
                    nom: data.nom || "",
                    email: data.email || "",
                    password: ""
                });
            });
        }
    }, [id]);

    function handleChange(e) {
        setForm({ ...form, [e.target.name]: e.target.value });
    }

    function handleSubmit(e) {
        e.preventDefault();
            const action = isEdit
                ? updateUserAdmin(id, form)
                : addUser(form);
                action
            .then(() => navigate("/admin/manage-users"))
            .catch(err => {console.error(err);swal('Error','Error de saisi','error');});
        
    }

    return (
        <div className="user-form-container">
            <div className="user-form-card">
                <h2>{isEdit ? "Modifier utilisateur" : "Ajouter utilisateur"}</h2>

                <form onSubmit={handleSubmit}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Nom</label>
                            <input
                                type="text"
                                name="nom"
                                value={form.nom}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label>Rôle</label>
                            
                            <strong className="eleveur-role">{form.role || 'Eleveur'}</strong>
                        </div>

                        <div className="form-group">
                            <label>Mot de passe {isEdit && "(laisser vide pour ne pas changer)"}</label>
                            <input
                                type="password"
                                name="password"
                                value={form.password}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <button className="submit-btn">
                        {isEdit ? "Enregistrer" : "Créer l'utilisateur"}
                    </button>
                </form>
            </div>
        </div>
    );
}
